import { useContext } from 'react';
import { EWIPDashboardScreenContext } from '../DashboardProvider';
import { Button, ButtonGroup, Card, CircularProgress, Grid, Typography } from '@material-ui/core';
import { Cell, Pie, PieChart, ResponsiveContainer, Sector } from 'recharts';
import './wipDashStyle.scss';
import { WipNoRecord, WipScreenLoader } from './wipDash-Loader';

const statusBorderColor = {
    "NOT Started": "#f44336",
    "Saved": "#ff9800",
    "Inspection Completed": "#4caf50",
    "Repair Required": "#ff5722",
    "Repair In Progress": "#2196f3",
    "Awaiting Sign Off": "#9c27b0",
    "Signed Off": "#009688",
    "Document Sent": "#795548",
};

const RADIAN = Math.PI / 180;


const WipDashboardAllInspectionCount = ({ onChartClickHandler }) => {
    const renderCustomizedLabel = ({
        cx,
        cy,
        midAngle,
        innerRadius,
        outerRadius,
        value,
    }) => {
        if (cx == null || cy == null || innerRadius == null || outerRadius == null) {
            return null;
        }

        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const ncx = Number(cx);
        const ncy = Number(cy);

        const x = ncx + radius * Math.cos(-(midAngle ?? 0) * RADIAN);
        const y = ncy + radius * Math.sin(-(midAngle ?? 0) * RADIAN);

        return (
            <text
                x={x}
                y={y}
                fill="white"
                textAnchor={x > ncx ? "start" : "end"}
                dominantBaseline="central"
                style={{ fontSize: 10, fontWeight: 800 }}
            >
                {value ?? 0}
            </text>
        );
    };

    // const MyCustomPie = (props: PieSectorShapeProps) => {
    //     return <Sector {...props} fill={COLORS[props.index % COLORS.length]} />;
    // };
    const { state, array, handlePieCard, handleChangeAssignedUser, COLORS, redirectToAssignedJobs } = useContext(EWIPDashboardScreenContext);
    return (
        <>
            {state.showHeaderLoader ? (
                <div className="wip-dash-Card">
                    <WipScreenLoader />
                </div>
            ) : (
                <Card className="wip-dash-Card" style={{ position: 'relative' }}>
                    <Grid container alignItems="center" spacing={2} justifyContent={array.selectedPieChartType == 'A' ? 'space-between' : 'flex-start'}>

                        <Grid item xs={12} sm={12}>
                            <Typography vraient="h5" color="secondary" className="dashHeading">
                                All Inspection Status
                            </Typography>
                        </Grid>



                        <Grid item xs={12}>
                            {array.allInspectionStatus.length == 0 ? (
                                <WipNoRecord />
                            ) : (
                                <>
                                    <div className="pieChartSize">
                                        <ResponsiveContainer>
                                            <PieChart>
                                                <text
                                                    x={75}
                                                    y={50}
                                                    textAnchor="middle"
                                                    dominantBaseline="middle"
                                                    fontWeight="bold"
                                                    onClick={() => redirectToAssignedJobs(null, true)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    {/* Total: */}
                                                    {array.overallInspectionTotal}
                                                </text>
                                                <Pie
                                                    data={array.allInspectionStatus}
                                                    cx={70}
                                                    cy={45}
                                                    paddingAngle={2}
                                                    outerRadius={50}
                                                    innerRadius={30}
                                                    fill="#8884d8"
                                                    dataKey="value"
                                                    // labelLine
                                                    // label={renderCustomizedLabel}
                                                    // isAnimationActive={isAnimationActive}
                                                    legendType='square'
                                                >
                                                    <legend></legend>

                                                    {array.allInspectionStatus.map((entry, index) => (
                                                        <>
                                                            <Cell
                                                                key={`cell-${index}`}
                                                                fill={COLORS[index % COLORS.length]}
                                                                style={{ cursor: 'pointer' }}
                                                            // onClick={() => redirectToAssignedJobs(entry, false)}
                                                            />
                                                        </>
                                                    ))}
                                                </Pie>
                                            </PieChart>
                                        </ResponsiveContainer>
                                    </div>
                                    <div className=" pie-job-list-inspection custom-scroll">
                                        {array.allInspectionStatus.map((m, i) => {
                                            let color = COLORS[i];
                                            return (
                                                <div style={{ padding: 0 }} key={m.workflow}>
                                                    <div
                                                        style={{
                                                            fontSize: 13,
                                                            maxWidth: 210,
                                                            minWidth: 110,
                                                            display: 'flex',
                                                            justifyContent: 'flex-start',
                                                            alignContent: 'center',
                                                        }}
                                                    >
                                                        {' '}
                                                        <div
                                                            style={{
                                                                background: color,
                                                                height: 10,
                                                                width: 10,
                                                                marginTop: 4
                                                            }}
                                                        ></div>
                                                        &nbsp;
                                                        <div style={{ fontWeight: 700, }}>&nbsp;{m.value}</div>&nbsp;
                                                        <div style={{ fontWeight: 600, fontSize: 12, }}>&nbsp;{m.name}</div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </>
                            )}
                        </Grid>
                    </Grid>
                </Card>
            )}
        </>
    );
};

export default WipDashboardAllInspectionCount;
